import { getSigner } from './getContract';

/**
 * Подпись под изменением расписания выплат.
 *
 * `PUT /perpetual/schedule/:address` — единственный запрос панели, который
 * что-то меняет на бэкенде, и единственный, который нельзя оставить открытым:
 * CORS останавливает чужой сайт в браузере, но не `curl`. Поэтому право
 * проверяется там же, где и всё остальное в системе, — в контракте: бэкенд
 * восстанавливает адрес подписанта и спрашивает `hasRole(ADMIN_ROLE, signer)`.
 *
 * Это `personal_sign`, а не транзакция: ни газа, ни токенов она не двигает.
 * Кошелёк показывает текст целиком, поэтому текст человекочитаемый.
 *
 * ⚠️ Формат обязан совпадать с `buildMessage` в
 * `../staking-back/src/services/scheduleAuthService.ts` до символа — иначе
 * восстановится чужой адрес и бэкенд ответит 401. Порядок строк задан там же.
 */
export const buildScheduleMessage = (address, changes, issuedAt) => {
  const lines = [
    'EMIVN Staking: изменение расписания выплат',
    `Кошелёк: ${address.toLowerCase()}`,
  ];

  if (changes.periodDays !== undefined) {
    lines.push(`Периодичность: ${changes.periodDays} дн.`);
  }

  if (changes.enabled !== undefined) {
    lines.push(`Автоклейм: ${changes.enabled ? 'включён' : 'выключен'}`);
  }

  lines.push(`Время: ${issuedAt}`);

  return lines.join('\n');
};

/**
 * @returns {Promise<{signature: string, issuedAt: string}>} заголовки для API
 */
export const signScheduleChange = async (address, changes) => {
  const issuedAt = new Date().toISOString();
  const signer = await getSigner();
  const signature = await signer.signMessage(
    buildScheduleMessage(address, changes, issuedAt),
  );

  return { signature, issuedAt };
};

export default signScheduleChange;
